<template>
  <notifications />
  <I18nEditorModal />
  <router-view />
</template>

